import type { Tables } from "@/src/types/database";
import { PUBLIC_SUPABASE_URL } from "$env/static/public";

export const getBucketLink = (): string => {
  return process.env.NODE_ENV === "development"
    ? `${PUBLIC_SUPABASE_URL}/storage/v1/object/public/content/cf/images/`
    : "https://media.casinofeber.se/"; // TODO: Use dynamic project key
};

export const getOperatorLogo = (project: { key: string }, logo: { [key: string]: string } | string = {}) => {
  const path = getBucketLink() + "operators";
  let fileName = "";

  if (typeof logo === "string") {
    fileName = logo;
  } else if (logo && typeof logo === "object") {
    fileName = logo[project?.key] || "";
  }

  if (!fileName) {
    fileName = "notfound.png";
  }

  if (fileName.includes("cf/images/operators/")) {
    const parts = fileName.split("cf/images/operators/");
    fileName = parts[parts.length - 1];
  }

  const result = `${path}/${fileName}`;
  return result;
};

export const getGameLogo = (project: Tables<"projects">, logo: { [key: string]: string } | string = {}) => {
  const path = getBucketLink() + "games";
  let fileName = "";

  if (typeof logo === "string") {
    fileName = logo;
  } else if (logo && typeof logo === "object") {
    fileName = logo[project?.key] || "";
  }

  if (!fileName) {
    fileName = "notfound.png";
  }

  if (fileName.includes("cf/images/games/")) {
    const parts = fileName.split("cf/images/games/");
    fileName = parts[parts.length - 1];
  }

  const result = `${path}/${fileName}`;
  return result;
};

export const getOperatorBackgroundImage = (
  project: Tables<"projects">,
  backgroundImage: { [key: string]: string } | string = {},
) => {
  const path = getBucketLink() + "operators_bg";
  let fileName = "";

  if (typeof backgroundImage === "string") {
    fileName = backgroundImage;
  } else if (backgroundImage && typeof backgroundImage === "object") {
    fileName = backgroundImage[project?.key] || "";
  }

  if (!fileName) {
    fileName = "no_bg_image.png";
  }

  if (fileName.includes("cf/images/operators_bg/")) {
    const parts = fileName.split("cf/images/operators_bg/");
    console.log(parts);
    fileName = parts[parts.length - 1];
  }

  const result = `${path}/${fileName}`;
  return result;
};

export const getBannerImage = (filename: string): string => {
  if (!filename) return "";

  const path = getBucketLink() + `banners/`;

  if (filename.includes("/images/banners/")) {
    const parts = filename.split("/images/banners/");
    filename = parts[parts.length - 1];
  }

  return `${path}/${filename}`;
};
